import React from "react";

const NoAccessPage: React.FC = (props) => {
  return (
    <div className="no-access-page">
      <h4>No Access, You don't have assigned any provider.</h4>
    </div>
  );
};

export default NoAccessPage;
